module.exports = __webpack_public_path__ + "img/logos-innobonos-2021-negativo.ec4dcd1d.png";